import { forwardRef } from "react";
import { SvgIcon, type SvgIconProps } from "@mui/material";

const Pdf = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 32 32" ref={ref} {...props}>
      <path d="M9.333 20.667h1.333V22H9.333v-1.333zm6.667 0h1.333v4H16v-4zm2.667-18H8a2.675 2.675 0 0 0-2.667 2.667v21.333c0 1.467 1.2 2.667 2.667 2.667h16c1.467 0 2.667-1.2 2.667-2.667v-16l-8-8zm-6 19.333c0 1.067-.933 2-2 2H9.334v2.667h-2v-8h3.333c1.067 0 2 .933 2 2V22zm6.666 2.667c0 1.067-.933 2-2 2H14v-8h3.333c1.067 0 2 .933 2 2v4zm5.334-4h-2V22h2v2h-2v2.667h-2v-8h4v2zM17.333 12V4.667L24.666 12h-7.333z" />
    </SvgIcon>
  );
});

Pdf.displayName = "Pdf";

export default Pdf;
